import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { AnnouncementService } from '../_services/announcement.service';
import { Router } from '@angular/router';


declare var $: any;

@Component({
  selector: 'app-announcement-alert',
  templateUrl: './announcement-alert.component.html',
  styleUrls: ['./announcement-alert.component.scss']
})

export class AnnouncementAlertComponent implements OnInit,OnDestroy {
  @Input() data;
  currLang
  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
    private announcementService: AnnouncementService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }
  closeModal() {
    $('#announcementModal').modal("hide");
  }

  setUp(event) {
    event.stopPropagation();
    this.announcementService.markAsReadAlert(this.data[0].id).subscribe(res => {
      $('#announcementModal').modal("hide");
      this.router.navigateByUrl('/names-sounds');
    })
  }
  postpone(event) {
    event.stopPropagation();
    this.announcementService.postponeAlert(this.data[0].id).subscribe(res => {
      $('#announcementModal').modal("hide");
    })
  }

  ngOnDestroy(){
    // to remove the dim screen after component destruction
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();  
  }
}